// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import themeConfig from '@configs/themeConfig'

// ** Axios Imports
import axios from 'axios'

export const getAllData = createAsyncThunk('employees/getAllData', async (employee) => {
  const config = {     
    headers: { 'Content-Type': 'application/json' }
}
  const getAllApi = "Employee/getEmployees/getEmployees"
  const response = await axios.post(themeConfig.data.API + getAllApi, JSON.stringify(employee), config)
  // console.log("uuu", JSON.parse(response.data.data))
  return JSON.parse(response.data.data)
})

export const employeesSlice = createSlice({
  name: 'employees',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedCountry: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
        state.allData.data = action.payload.VW_EMPLOYEELIST
        state.data = action.payload.VW_EMPLOYEELIST
      })
  }
})

export default employeesSlice.reducer
